/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Swipe4Work Employer API
 * OpenAPI spec version: 0.1.1
 */

export type PermissionResource = typeof PermissionResource[keyof typeof PermissionResource];


export const PermissionResource = {
  Dashboard: 'Dashboard',
  CompanyProfile: 'CompanyProfile',
  CompanySettings: 'CompanySettings',
  CompanyBilling: 'CompanyBilling',
  Job: 'Job',
  JobApplication: 'JobApplication',
  Scout: 'Scout',
  Match: 'Match',
  Full: 'Full',
  CustomerOnboarding: 'CustomerOnboarding',
  ConferenceOnboarding: 'ConferenceOnboarding',
  ConferenceSwipe: 'ConferenceSwipe',
  Lead: 'Lead',
} as const;
